import { useState } from 'react';
import Language from '../../../common/decorators/Language';
import Single from '../../../layouts/single/Single/Single';
import DocumentsView from '../../../views/documents/DocumentsView';
import { getDefaultStaticProps, getLangPaths } from '../../api/_props';
import T from '../../../common/components/T';
const project = require('../../../scripts/configs/project');

const DocumentsPage = ({ translates }) => {
    const [breadcrumbs, setBreadcrumbs] = useState([
        {
            title: <T textName='mainPageTitle' defaultStr='Главная' />,
            link: '/'
        },
        {
            title: <T textName='documents' defaultStr='Документы' page='/documents' />,
            link: '/documents'
        },
        {
            title: <T textName='contracts' defaultStr='Договора' page='/documents' />,
            link: '/documents'
        }
    ]);
    return (
        <Language translates={translates} page={'/documents'}>
            <Single
                title={<T textName='documents' defaultStr='Документы' page='/documents' />}
                alias='documents'
                translates={translates}
                breadcrumbs={breadcrumbs}
            >
                <DocumentsView setBreadcrumbs={setBreadcrumbs} />
            </Single>
        </Language>
    );
};

export async function getStaticProps({ params }) {
    const defaultProps = await getDefaultStaticProps(params?.lang, '/documents', ['/']);
    if (!defaultProps?.props) {
        return defaultProps;
    }
    return {
        props: {
            ...defaultProps?.props
        },
        revalidate: project?.revalidate
    };
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}
export default DocumentsPage;
